<script lang="ts">
  import CitaAsistenteWidget from './CitaAsistenteWidget.svelte';
  import { infoClinica, type ClinicaPublicaInfo } from '../lib/citas-publico';

  const path = typeof location !== 'undefined' ? location.pathname : '';
  const match = path.match(/^\/agendar\/([^/]+)/);
  const tenantFromPath = match?.[1] ?? '';
  const tenantFromQuery = typeof location !== 'undefined'
    ? new URLSearchParams(location.search).get('tenant') ?? ''
    : '';

  let tenantId = $state(tenantFromPath || tenantFromQuery);
  let inputTenant = $state('');
  let clinica = $state<ClinicaPublicaInfo | null>(null);
  let cargando = $state(false);
  let error = $state<string | null>(null);

  async function cargar(id: string) {
    if (!id.trim()) return;
    cargando = true;
    error = null;
    clinica = null;
    try {
      clinica = await infoClinica(id.trim());
      tenantId = id.trim();
      if (typeof history !== 'undefined') {
        history.replaceState(null, '', `/agendar/${encodeURIComponent(tenantId)}`);
      }
    } catch (e: any) {
      error = e?.message ?? 'No se pudo cargar la clinica';
    } finally {
      cargando = false;
    }
  }

  $effect(() => {
    if (tenantFromPath || tenantFromQuery) void cargar(tenantFromPath || tenantFromQuery);
  });
</script>

<div class="page">
  <div class="wrap">
    <h1>Agendar cita en línea</h1>
    <p class="lead">Asistente con texto y voz. Recibirá recordatorio por WhatsApp ~24 h antes y otro el día de la cita a las 7:00 a.m.</p>

    {#if !clinica && !cargando}
      <form class="picker" onsubmit={(e) => { e.preventDefault(); void cargar(inputTenant); }}>
        <label>
          Código de su clínica
          <input bind:value={inputTenant} placeholder="ej. clinica-solo-medico" required />
        </label>
        <p class="hint">Demos: clinica-solo-medico · clinica-demo-vet · clinica-demo-odonto</p>
        <button type="submit">Continuar</button>
      </form>
    {/if}

    {#if cargando}<p class="wait">Cargando…</p>{/if}
    {#if error}<p class="err">{error}</p>{/if}

    {#if clinica}
      <CitaAsistenteWidget tenantId={tenantId} {clinica} />
    {/if}
  </div>
</div>

<style>
  .page {
    min-height: 100vh; background: linear-gradient(160deg, #e6fafa 0%, #f8fafc 50%);
    display: flex; align-items: center; justify-content: center; padding: 24px 16px;
  }
  .wrap { width: 100%; max-width: 480px; }
  h1 { margin: 0 0 8px; font-size: 1.5rem; color: #16a34a; text-align: center; }
  .lead { margin: 0 0 20px; color: #4b5563; font-size: 0.95rem; text-align: center; line-height: 1.5; }
  .picker {
    background: #fff; padding: 20px; border-radius: 12px; box-shadow: 0 4px 16px rgba(0,0,0,.08);
    display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px;
  }
  .picker label { display: flex; flex-direction: column; gap: 6px; font-size: 14px; font-weight: 600; color: #374151; }
  .picker input { padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; }
  .picker button {
    background: #16a34a; color: #fff; border: none; border-radius: 8px;
    padding: 10px; font-weight: 600; cursor: pointer;
  }
  .hint { margin: 0; font-size: 12px; color: #6b7280; text-align: center; }
  .wait, .err { text-align: center; font-size: 14px; }
  .err { color: #b91c1c; }
</style>
